import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("comparison-table", () => {
    it("should render the comparison-table component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-comparison-table></ux-comparison-table>`);
        const tableComponent = await page.find("ux-comparison-table");
        expect(tableComponent).toHaveClass("hydrated");
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-comparison-table>
            <table>
                <thead>
                    <tr>
                        <th scope="col" class="first"></th>
                        <th scope="col">
                            Plasmaschneiden
                        </th>
                        <th scope="col">
                            Autogenes Brennschneiden
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td
                            class="ux-comparison-table__heading"
                            colspan="2"
                        >
                            Konturflexibilität
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Sehr hoch. Niedrige Schnittfuge von &lt; 0,5
                            mm mit akkuraten Winkeln und sehr kleinen
                            Löchern
                        </td>
                        <td>
                            Niedrig. Hohe Schnittfuge von 1 mm bis 4 mm,
                            keine inneren Konturen mit spitzen Winkeln,
                            Ecken ungenau und „abgerundet“, kleinste
                            Lochgröße muss ein bis dreimal größer als
                            die Blechdicke sein, hoher Wärmeeinsatz
                        </td>
                    </tr>
                </tbody>
            </table>
        </ux-comparison-table>`);
    });

    it("should render valid html with the data-table attribute", async () => {
        await testValidHtml(`<ux-comparison-table data-table>
                <table class="compare-module-simple">
                    <thead>
                        <tr>
                            <th scope="col" class="first"></th>
                            <th scope="col">
                                TruLaser 3030
                            </th>
                            <th scope="col">
                                TruLaser 3040
                            </th scope="col">
                            <th scope="col">
                                TruLaser 9000
                            </th>
                            <th scope="col">
                                TruLaser 90001
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="cat">
                            <td
                                class="first ux-comparison-table__heading"
                            >
                                Abmessungen
                            </td>
                        </tr>
                        <tr class="sub-cat">
                            <td class="first">Länge</td>
                            <td>9300 mm</td>
                            <td>12000 mm</td>
                            <td>12000 mm</td>
                            <td>12000 mm</td>
                        </tr>
                        <tr class="sub-cat">
                            <td class="first">Breite</td>
                            <td>4700 mm</td>
                            <td>5300 mm</td>
                            <td>5300 mm</td>
                            <td>5300 mm</td>
                        </tr>
                        <tr class="sub-cat">
                            <td class="first">Höhe</td>
                            <td>2200 mm</td>
                            <td>2200 mm</td>
                            <td>2200 mm</td>
                            <td>2200 mm</td>
                        </tr>
                        <tr class="cat">
                            <td
                                class="first ux-comparison-table__heading"
                                colspan="3"
                            >
                                Maximale Geschwindigkeit
                            </td>
                        </tr>
                        <tr class="sub-cat">
                            <td class="first">Simultan</td>
                            <td>140 m/min</td>
                            <td>140 m/min</td>
                            <td>140 m/min</td>
                            <td>140 m/min</td>
                        </tr>
                        <tr class="cat">
                            <td
                                class="first ux-comparison-table__heading"
                                colspan="3"
                            >
                                Arbeitsbereich
                            </td>
                        </tr>
                        <tr class="sub-cat">
                            <td class="first">X-Achse</td>
                            <td>3000 mm</td>
                            <td>3000 mm</td>
                            <td>4000 mm</td>
                            <td>4000 mm</td>
                        </tr>
                        <tr class="sub-cat">
                            <td class="first">Y-Achse</td>
                            <td>1500 mm</td>
                            <td>2000 mm</td>
                            <td>1500 mm</td>
                            <td>2000 mm</td>
                        </tr>
                        <tr class="sub-cat">
                            <td class="first">
                                Max. Gewicht
                            </td>
                            <td>900 kg</td>
                            <td>1700 kg</td>
                            <td>1700 kg</td>
                            <td>1700 kg</td>
                        </tr>
                    </tbody>
                </table>
            </ux-comparison-table>`);
    });
});
